<div class="app-main-content clearfix border-box col-12 mx-auto pt2 pb3 overflow-hidden relative">
  <ng-content></ng-content>
</div>
